module.exports = __webpack_public_path__ + "img/fiducia_logo.60060318.png";